import React, { useState } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { useFormatDate } from 'hooks';
import { toast } from 'react-toastify';
import Select from 'react-select';
import firebase from './../../../firebase';
import { Button, Col, OverlayTrigger, Tooltip, Form, Row } from 'react-bootstrap';
import logoAirbnb from 'assets/img/logos/airbnb_logo.png';
import logoexpedia from 'assets/img/logos/expedia.png';
import logoabritel from 'assets/img/logos/abritel.png';
import logodirect from 'assets/img/logoIcon.png';
import tripadvisor from 'assets/img/logos/tripadvisor.jpg';
import locasun from 'assets/img/logos/locasun.png';
import homeToGo from 'assets/img/logos/homeToGo.jpeg'
import kayak from 'assets/img/logos/kayak.webp'
import homerez from 'assets/img/logos/homerez.png'
import booking from 'assets/img/logos/booking.png'
import fr from 'date-fns/locale/fr';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';
import { makeCsv, getTableDataForExport, getColKeyArrayObject } from 'state/actions/users';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Comptabilite = () => {
  registerLocale('fr', fr);
  setDefaultLocale('fr');
  const [l, setL] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [alldata, setAllData] = React.useState([]);
  const [checkIn, setCheckIn] = React.useState(null);
  const [checkOut, setCheckOut] = React.useState(null);
  const [colexport, setColExport] = React.useState([]);
  const [formd, setFrom] = React.useState({});
  const [moislist, setMoisList] = React.useState([]);
  const [valueMonth, setValueMonth] = React.useState(null);
  const [yearlist, setYearList] = React.useState([]);
  const [valueYear, setValueYear] = React.useState(null);
  const [clientName, setClientName] = React.useState("");
  const logo = (l) => {

    switch (l?.value) {
      case "booking":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={booking}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "homerez":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={homerez}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "kayak":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={kayak}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "homeToGo":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={homeToGo}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "locasun":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={locasun}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "tripadvisor":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={tripadvisor}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "direct":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={logodirect}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "abritel":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={logoabritel}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "airbnb":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={logoAirbnb}
            alt={l}
            width={30}
          />
        </OverlayTrigger>
      case "expedia":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={logoexpedia}
            alt={l}
            width={30}
          />
        </OverlayTrigger>

      default:
        return <span>{l?.label}</span>;
    }
  }

  function isDateValid(dateString) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  function estDansLaPlage(dateDebut, dateFin, plageDebut, plageFin) {
    return dateDebut >= plageDebut && dateFin <= plageFin;
  }

  function getUniqueYears(dates) {
    // Convertir les objets Date en années et les ajouter à un Set pour éliminer les doublons
    const uniqueYears = new Set(dates.map(date => date.getFullYear()));

    // Convertir le Set en tableau trié
    return Array.from(uniqueYears).sort((a, b) => a - b);
  }


  const sortByCheckin = (array) => {
    return array.sort((a, b) => a.checkin.toDate() - b.checkin.toDate());
  };

  const loadBooking = () => {
    setL(true);
    firebase.firestore().collection('bookings').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        l.id = d.id;
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          if (l.statut.value === "confirmed" || l.statut.value === "canceled") {
            l.villa = l.property.label || ""
            l.cl = l.client?.label || ""
            s.push(l)
          }

        }

      })
      // console.log("data", s)
      const options = { month: 'long' };
      const mo = []
      s.forEach((e, i) => {
        if (typeof e?.checkin?.toDate === 'function' && isDateValid(e?.checkin?.toDate())) {
          let c = e?.checkin?.toDate()
          const monthLabel = c.toLocaleString('fr-FR', options);
          // console.log("c in", monthLabel) 
          const year = c.getFullYear();
          if (!mo.includes(`${monthLabel}-${year}`)) {
            mo.push(`${monthLabel}-${year}`)
          }
          s[i].pre = `${monthLabel}-${year}`;
        }
        if (typeof e?.checkout?.toDate === 'function' && isDateValid(e?.checkout?.toDate())) {
          let c = e?.checkout?.toDate()
          const monthLabel = c.toLocaleString('fr-FR', options);
          // console.log("c out", monthLabel) 
          const year = c.getFullYear();
          if (!mo.includes(`${monthLabel}-${year}`)) {
            mo.push(`${monthLabel}-${year}`)
          }
        }
      });
      // console.log(mo)

      // Convertir les dates en objets Date
      const dateObjects = mo.map(dateStr => {
        const [month, year] = dateStr.split('-');
        return new Date(parseInt(year), getMonthIndex(month), 1);
      });

      // Fonction pour obtenir l'index du mois à partir de son nom
      function getMonthIndex(monthName) {
        const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
        return months.indexOf(monthName.toLowerCase());
      }

      // Trier les dates
      dateObjects.sort((a, b) => a - b);

      // Convertir les objets Date triés en chaînes de dates dans le format initial
      const sortedDates = dateObjects.map(date => {
        const month = date.toLocaleString('fr-FR', { month: 'long' });
        const year = date.getFullYear();
        return `${month}-${year}`;
      });
      const uniqueYears = getUniqueYears(dateObjects);
      const uy = uniqueYears.map(y => {
        return { value: y, label: y };
      })
      setYearList(uy)

      // console.log(sortedDates);
      let ms = []
      sortedDates.forEach(sd => {
        ms.push({ value: sd, label: sd })
      })
      setMoisList(ms)
      const sortedData = sortByCheckin(s);
      setAllData(sortedData)
      setData(sortedData);

      setColExport(getColKeyArrayObject(s));
      setL(false);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }




  const columns = [
    {
      accessor: 'origin',
      Header: 'Origine',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => (
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          {logo(row.original?.origin)}
        </div>
      )
    },
    {
      accessor: 'villa',
      Header: 'Villa',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => (

        <>
          <span>{row.original.villa}</span>
          <br />
          {row?.original?.checkin && row?.original?.checkin?.toDate !== undefined && (
            <small className="has-text-grey is-abbr-like">
              {useFormatDate(row.original?.checkin?.toDate(), {
                day: 'numeric',
                weekday: 'short',
                year: 'numeric',
                month: 'short',
              })}
            </small>
          )}
          <br />
          {row?.original?.checkout && row?.original?.checkout?.toDate !== undefined && (
            <small className="has-text-grey is-abbr-like">
              {useFormatDate(row.original?.checkout?.toDate(), {
                day: 'numeric',
                weekday: 'short',
                year: 'numeric',
                month: 'short',
              })}
            </small>
          )}

          {row.original.client?.label && (<><br /><span>{row.original.client.label}</span>
          </>)}
        </>
      )
    },
    {
      accessor: 'deposituser',
      Header: 'Acompte',
      headerProps: { className: 'text-900' },
      Cell: rowData => {

        const { deposituser, id, depositFinish } = rowData.row.original
        const [load, setL] = useState(false);
        const [valuedeposit, setValueDeposit] = useState("");
        const [ldesposit, setLdeposit] = useState(deposituser || [])
        const [loading, setLoading] = useState(false)
        const [date, setDate] = useState(null);
        const [sadd, setAdd] = useState(false);
        const [finish, setFinish] = useState(depositFinish ? depositFinish : false);



        const finishing = () => {
          if (loading) {
            return;
          }
          setLoading(true)
          firebase.firestore().collection('bookings').doc(id).update({ depositFinish: true }).then(() => {
            setL(true);
            setDate(null);
            toast.success('Acompte: Terminé.')
            setAdd(false);
            // mettre a jour et vider les champs
            setLoading(false);
            setFinish(true)
            setTimeout(() => {
              setL(false);
            }, 1000);
          }).catch((err) => {
            setLoading(false);
            toast.error("Acompte: une erreur s'est produite")
          })
        }

        const handleSubmit = (event) => {
          // const form = event.currentTarget;
          event.preventDefault();
          event.stopPropagation();

          // récup le tableau d'acompte actuelle
          // ajouter les nouvelles valeur {}
          let vr = ldesposit;
          vr.push({
            name: event.target?.name?.value,
            deposit: valuedeposit,
            date: date
          })
          // console.log('form', vr);
          // return;
          if (valuedeposit && event.target?.name?.value && date) {
            let val = Number(valuedeposit.replace(",", "."))
            if (val > 0) {
              if (loading) {
                return;
              }
              setLoading(true);
              firebase.firestore().collection('bookings').doc(id).update({ deposituser: vr }).then(() => {
                setL(true);
                setDate(null);
                toast.success('Acompte: Mise à jour.')
                setLdeposit(vr)
                setAdd(false);
                // mettre a jour et vider les champs
                setLoading(false);
                setTimeout(() => {
                  setL(false);
                }, 1000);
              }).catch((err) => {
                setLoading(false);
                toast.error("Acompte: Les champs sont invalide")
              })
            } else {
              toast.error("Acompte: Les champs sont invalide")
            }
          } else {
            toast.error("Acompte : Le champs est invalide")
          }
        }

        if (ldesposit.length > 0) {
          return <>
            {finish && (
              <div style={{ display: 'flex', justifyContent: "end", paddingBottom: 10 }}>
                <FontAwesomeIcon
                  icon={'check'}
                  className="text-success fa-check "
                />
              </div>
            )}
            {ldesposit?.map((d) => {
              return <>
                <small className="has-text-grey is-abbr-like">
                  {d?.name} <span style={{ fontWeight: "bold" }}>{d?.deposit} €</span> le {useFormatDate(typeof d?.date?.toDate === 'function' ? d?.date?.toDate() : d?.date, {
                    day: 'numeric',
                    year: 'numeric',
                    month: 'short',
                  })}
                </small>
                <br />
              </>
            })}
            {!sadd && !finish && (
              <div style={{ display: 'flex', justifyContent: "space-between", marginTop: 20 }}>
                <a href="#" onClick={() => { setAdd(true) }}>
                  <FontAwesomeIcon
                    icon={'plus'}
                    className="text-primary fa-check"
                  /></a>

                <a href="#" onClick={() => {
                  if (confirm("Terminé ?")) {
                    finishing()
                  }
                }}>
                  <FontAwesomeIcon
                    icon={'check'}
                    className="text-primary fa-check"
                  /></a>
              </div>
            )}
            {sadd && !load && (
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="deposit">
                  <Form.Control
                    type="text"
                    name="name"
                    required
                    autocomplete="off"
                    placeholder="Nom Prénom"
                  />
                  <Form.Control
                    type="text"
                    name="deposit"
                    required
                    autocomplete="off"
                    placeholder="1000 €"
                    onChange={e => {
                      setValueDeposit(e.target.value)
                    }}
                  />
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={date}
                    selectsStart
                    autocomplete="off"
                    onChange={newDate => {
                      setDate(newDate)
                    }}
                    customInput={
                      <CustomDateInput
                        formControlProps={{
                          autocomplete: "off",
                          placeholder: 'jj/mm/aaaa',
                          //     ...register(`ScheduleStartDate${index}`)
                        }}
                      />
                    }
                  />
                </Form.Group>

                <Form.Group   >
                  {/* <Form.Label>(€ sans symbole)</Form.Label> */}
                  <div style={{ display: 'flex', justifyContent: "space-between" }}>
                    <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
                    <a href="#" onClick={() => {
                      setAdd(false)
                    }}>Annuler</a>
                  </div>
                </Form.Group>
              </Form>
            )}
          </>
        }

        return <>
          {!load && (
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="deposit">
                <Form.Control
                  type="text"
                  name="name"
                  required
                  autocomplete="off"
                  placeholder="Nom Prénom"
                />
                <Form.Control
                  type="text"
                  name="deposit"
                  required
                  autocomplete="off"
                  placeholder="1000 €"
                  onChange={e => {
                    setValueDeposit(e.target.value)
                  }}
                />
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={date}
                  selectsStart
                  autocomplete="off"
                  onChange={newDate => {
                    setDate(newDate)
                  }}
                  customInput={
                    <CustomDateInput
                      formControlProps={{
                        autocomplete: "off",
                        placeholder: 'jj/mm/aaaa',
                        //     ...register(`ScheduleStartDate${index}`)
                      }}
                    />
                  }
                />
              </Form.Group>

              <Form.Group   >
                {/* <Form.Label>(€ sans symbole)</Form.Label> */}
                <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
              </Form.Group>
            </Form>
          )}
        </>

      }
    },
    {
      accessor: 'security',
      Header: 'Caution',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { securityuser, securityFinish, id, renduDate } = rowData.row.original
        const [load, setL] = useState(false);
        const [valuesecurity, setValueSecurity] = useState("");
        const [lsecurity, setLsecurity] = useState(securityuser || [])
        const [loading, setLoading] = useState(false)
        const [date, setDate] = useState(null);
        const [sadd, setAdd] = useState(false);
        const [finish, setFinish] = useState(securityFinish ? securityFinish : false);
        const [rendu, setRendu] = useState(renduDate?.toDate() || null)
        const [rendre, setRendre] = useState(false)
        const jeRends = () => {
          if (confirm("Je confirme avoir rendu la caution?")) {
            if (loading) {
              return;
            }
            setLoading(true)
            firebase.firestore().collection('bookings').doc(id).update({ renduDate: date }).then(() => {
              setL(true);
              toast.success('Caution: Rendu.')
              setAdd(false);
              // mettre a jour et vider les champs
              setLoading(false);
              setRendu(date)
              setTimeout(() => {
                setL(false);
                setDate(null);
              }, 1000);
            }).catch((err) => {
              setLoading(false);
              toast.error("Caution: une erreur s'est produite")
            })
          }

        }

        const finishing = () => {
          if (loading) {
            return;
          }
          setLoading(true)
          firebase.firestore().collection('bookings').doc(id).update({ securityFinish: true }).then(() => {
            setL(true);
            setDate(null);
            toast.success('Acompte: Terminé.')
            setAdd(false);
            // mettre a jour et vider les champs
            setLoading(false);
            setFinish(true)
            setTimeout(() => {
              setL(false);
            }, 1000);
          }).catch((err) => {
            setLoading(false);
            toast.error("Acompte: une erreur s'est produite")
          })
        }
        const handleSubmitRendre = (event) => {
          event.preventDefault();
          event.stopPropagation();
          jeRends()
        }

        const handleSubmit = (event) => {
          // const form = event.currentTarget;
          event.preventDefault();
          event.stopPropagation();

          // récup le tableau d'acompte actuelle
          // ajouter les nouvelles valeur {}
          let vr = lsecurity;
          vr.push({
            name: event.target?.name?.value,
            deposit: valuesecurity,
            date: date
          })

          if (valuesecurity && event.target?.name?.value && date) {
            let val = Number(valuesecurity.replace(",", "."))
            if (val > 0) {
              if (loading) {
                return;
              }
              // console.log("securityuser", vr) 
              setLoading(true);
              firebase.firestore().collection('bookings').doc(id).update({ securityuser: vr }).then(() => {
                setL(true);
                setDate(null);
                toast.success('Caution: Mise à jour.')
                setLsecurity(vr)
                setAdd(false);
                // mettre a jour et vider les champs
                setLoading(false);
                setTimeout(() => {
                  setL(false);
                }, 1000);
              }).catch((err) => {
                console.error("err", err)
                setLoading(false);
                toast.error("Caution: Les champs sont invalide")
              })
            } else {
              toast.error("Caution: Les champs sont invalide")
            }
          } else {
            toast.error("Caution : Le champs est invalide")
          }
        }

        if (lsecurity.length > 0) {
          return <>
            {finish && (
              <div style={{ display: 'flex', justifyContent: "end", paddingBottom: 10 }}>
                <FontAwesomeIcon
                  icon={'check'}
                  className="text-success fa-check "
                />
              </div>
            )}
            {lsecurity?.map((d) => {
              return <>
                <small className="has-text-grey is-abbr-like">
                  {d?.name} <span style={{ fontWeight: "bold" }}>{d?.deposit} €</span> le {useFormatDate(typeof d?.date?.toDate === 'function' ? d?.date?.toDate() : d?.date, {
                    day: 'numeric',
                    year: 'numeric',
                    month: 'short',
                  })}
                </small>
                <br />
              </>
            })}
            {!sadd && !finish && (
              <div style={{ display: 'flex', justifyContent: "space-between", marginTop: 20 }}>
                <a href="#" onClick={() => { setAdd(true) }}>
                  <FontAwesomeIcon
                    icon={'plus'}
                    className="text-primary fa-check"
                  /></a>

                <a href="#" onClick={() => {
                  if (confirm("Terminé ?")) {
                    finishing()
                  }
                }}>
                  <FontAwesomeIcon
                    icon={'check'}
                    className="text-primary fa-check"
                  /></a>
              </div>
            )}
            {sadd && !load && (
              <Form onSubmit={handleSubmit}>
                <Form.Group  >
                  <Form.Control
                    type="text"
                    name="name"
                    required
                    autocomplete="off"
                    placeholder="Nom Prénom"
                  />
                  <Form.Control
                    type="text"
                    name="security"
                    required
                    autocomplete="off"
                    placeholder="1000 €"
                    onChange={e => {
                      setValueSecurity(e.target.value)
                    }}
                  />
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={date}
                    selectsStart
                    autocomplete="off"
                    onChange={newDate => {
                      setDate(newDate)
                    }}
                    customInput={
                      <CustomDateInput
                        formControlProps={{
                          autocomplete: "off",
                          placeholder: 'jj/mm/aaaa',
                          //     ...register(`ScheduleStartDate${index}`)
                        }}
                      />
                    }
                  />
                </Form.Group>

                <Form.Group   >
                  {/* <Form.Label>(€ sans symbole)</Form.Label> */}
                  <div style={{ display: 'flex', justifyContent: "space-between" }}>
                    <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
                    <a href="#" onClick={() => {
                      setAdd(false)
                    }}>Annuler</a>
                  </div>
                </Form.Group>
              </Form>
            )}
            {finish && (
              <>
                {rendu ? (
                  <span className='text-warning'>Rendu le: {useFormatDate(rendu, {
                    day: 'numeric',
                    year: 'numeric',
                    month: 'short',
                  })}</span>
                ) : (
                  <>
                    {!rendre ? (<a href="#" onClick={() => {
                      setDate(new Date())
                      setRendre(true)
                    }}>Je rend</a>) : (
                      <Form onSubmit={handleSubmitRendre}>
                        <Form.Group  >
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            selected={date}
                            selectsStart
                            autocomplete="off"
                            onChange={newDate => {
                              setDate(newDate)
                            }}
                            customInput={
                              <CustomDateInput
                                formControlProps={{
                                  autocomplete: "off",
                                  placeholder: 'jj/mm/aaaa',
                                  //     ...register(`ScheduleStartDate${index}`)
                                }}
                              />
                            }
                          />
                        </Form.Group>

                        <Form.Group   >
                          {/* <Form.Label>(€ sans symbole)</Form.Label> */}
                          <div style={{ display: 'flex', justifyContent: "space-between" }}>
                            <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
                            <a href="#" onClick={() => {
                              setRendre(false)
                            }}>Annuler</a>
                          </div>
                        </Form.Group>
                      </Form>
                    )}

                  </>
                )}

              </>
            )}
          </>
        }


        return <>
          {!load && (
            <Form onSubmit={handleSubmit}>
              <Form.Group  >
                <Form.Control
                  type="text"
                  name="name"
                  required
                  autocomplete="off"
                  placeholder="Nom Prénom"
                />
                <Form.Control
                  type="text"
                  name="security"
                  required
                  autocomplete="off"
                  placeholder="1000 €"
                  onChange={e => {
                    setValueSecurity(e.target.value)
                  }}
                />
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={date}
                  selectsStart
                  autocomplete="off"
                  onChange={newDate => {
                    setDate(newDate)
                  }}
                  customInput={
                    <CustomDateInput
                      formControlProps={{
                        autocomplete: "off",
                        placeholder: 'jj/mm/aaaa',
                        //     ...register(`ScheduleStartDate${index}`)
                      }}
                    />
                  }
                />
              </Form.Group>

              <Form.Group   >
                <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
              </Form.Group>
            </Form>

          )}
        </>

      }
    },
    {
      accessor: 'commission',
      Header: 'Commission HT',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { commission, id } = rowData.row.original
        const [lcommission, setLcommission] = useState(commission || null)
        const [loading, setLoading] = useState(false)

        const handleSubmit = (event) => {
          // const form = event.currentTarget;
          event.preventDefault();
          event.stopPropagation();

          // console.log('form', event.target?.deposit?.value)
          if (event.target?.commission?.value) {
            let val = Number(event.target?.commission?.value)
            if (val > 0) {
              setLoading(true);
              firebase.firestore().collection('bookings').doc(id).update({ commission: event.target?.commission?.value }).then(() => {
                toast.success('Commission: Mise à jour.')
                setLcommission(event.target?.commission?.value)
                setLoading(false);
              }).catch((err) => {
                setLoading(false);
                toast.error("Commission : Le champs est invalide")
              })
            } else {
              toast.error("Commission : Le champs est invalide")
            }
          } else {
            toast.error("Commission : Le champs est invalide")
          }
        }

        if (lcommission) {
          return <>
            <div>
              <div style={{ paddingBottom: 10 }}>
                <FontAwesomeIcon
                  icon={'check'}
                  className="text-success fa-check "
                />
                <a style={{ marginLeft: 10, cursor: "pointer" }} onClick={() => {
                  setLcommission(null)
                }}>
                  <FontAwesomeIcon
                    icon={'edit'}
                    className="text-warning fa-edit "
                  />
                </a>
              </div>
            </div>
            <span>{parseFloat(lcommission).toFixed(2)} €</span>
          </>
        } else {
          return <>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="commission">
                <Form.Control
                  type="text"
                  name="commission"
                  required
                  placeholder="1000"
                />
              </Form.Group>
              <Form.Group   >
                {/* <Form.Label>(€ sans symbole)</Form.Label> */}
                <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
              </Form.Group>
            </Form>
            {commission && <a className="text-primary " onClick={() => { setLcommission(commission) }}>annuler</a>}
          </>
        }

      }
    },
    {
      accessor: 'apporteur',
      Header: 'Apporteur HT',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => {
        const { apporteuruser, id, apporteurFinish } = row.original
        const [hasApporteur, setHasApporteur] = useState(apporteuruser?.length > 0 ? true || false : false);
        const [load, setL] = useState(false);
        const [valueapporteur, setValueApporteur] = useState("");
        const [lapporteur, setLApporteur] = useState(apporteuruser || [])
        const [loading, setLoading] = useState(false)
        const [date, setDate] = useState(null);
        const [sadd, setAdd] = useState(false);
        const [finish, setFinish] = useState(apporteurFinish ? apporteurFinish : false);
        const [edit, setEdit] = useState(false);
        const [editIndex, setEditIndex] = useState(null);

        const finishing = () => {
          if (loading) {
            return;
          }
          setLoading(true)
          firebase.firestore().collection('bookings').doc(id).update({ apporteurFinish: true }).then(() => {
            setL(true);
            setDate(null);
            toast.success('Apporteur: Terminé.')
            setAdd(false);
            // mettre a jour et vider les champs
            setLoading(false);
            setFinish(true)
            setTimeout(() => {
              setL(false);
            }, 1000);
          }).catch((err) => {
            setLoading(false);
            toast.error("Apporteur: une erreur s'est produite")
          })
        }

        const handleSubmitEdit = (event) => {
          event.preventDefault();
          event.stopPropagation();
          let vr = []
          let total = 0;
          lapporteur.forEach((v) => {
            vr.push({
              name: v.name,
              apporteur: v.apporteur,
              date: v.date.seconds ? v.date.toDate() : v.date
            }) 
            total += Number(v?.apporteur?.replace(",", "."))
          })

            
          let d = {
            has: true,
            price: total,
            name:'total', 
          }

          if (loading) {
            return;
          }
          setLoading(true);
          firebase.firestore().collection('bookings').doc(id).update({ apporteuruser: vr, apporteur: d }).then(() => {
              toast.success('Apporteur: Modifié avec succès.')
          }).finally(()=> {
            setEdit(false);
            setEditIndex(null);
            setLoading(false); 
          })
        }

        const handleSubmit = (event) => {
          event.preventDefault();
          event.stopPropagation();
          let vr = lapporteur;
          let total = 0;
          vr.push({
            name: event.target?.name?.value,
            apporteur: valueapporteur,
            date: date
          })
          
          vr.forEach((sr) => {
            total += Number(sr?.apporteur?.replace(",", "."))
          })

            
          let d = {
            has: true,
            price: total,
            name: 'total'
          }


          if (valueapporteur && event.target?.name?.value && date) {
            let val = Number(valueapporteur.replace(",", "."))
            if (val != null) {
              if (loading) {
                return;
              }
              setLoading(true);
              firebase.firestore().collection('bookings').doc(id).update({ apporteuruser: vr, apporteur: d }).then(() => {
                setL(true);
                setDate(null);
                toast.success('Apporteur: Mise à jour.')
                setLApporteur(vr)
                setAdd(false);
                // mettre a jour et vider les champs
                setLoading(false);
                setTimeout(() => {
                  setL(false);
                }, 1000);
              }).catch((err) => {
                setLoading(false);
                toast.error("Apporteur: Les champs sont invalide")
              })
            } else {
              toast.error("Apporteur: Les champs sont invalide")
            }
          } else {
            toast.error("Apporteur : Le champs est invalide")
          }
        }

        if (lapporteur.length > 0) {
          return <> 
            {lapporteur?.map((d, i) => {
              return <> 
                {finish && !edit && (
                  <>
                    <a href="#" onClick={() => {
                      if (confirm("Modifié ?")) {
                        setDate(lapporteur[i].date?.seconds ? lapporteur[i].date?.toDate() : lapporteur[i].date)
                        setEditIndex(i)
                        setEdit(true)
                      }
                    }}>
                      <FontAwesomeIcon
                        icon={'edit'}
                        className="text-warning fa-edit"
                      /></a>
                  </>
                )}
                {!edit && (
                  <>
                    <small className="has-text-grey is-abbr-like">
                      {d?.name} <span style={{ fontWeight: "bold" }}>{d?.apporteur} €</span> le {useFormatDate(typeof d?.date?.toDate === 'function' ? d?.date?.toDate() : d?.date, {
                        day: 'numeric',
                        year: 'numeric',
                        month: 'short',
                      })}
                    </small><br />
                  </>
                )}


              </>
            })}

            {edit && (
              <>
                <Form onSubmit={handleSubmitEdit}>
                  <Form.Group controlId="apporteur">
                    <Form.Control
                      type="text"
                      name="name"
                      defaultValue={lapporteur[editIndex].name}
                      required
                      autocomplete="off"
                      placeholder="Nom Prénom"
                      onChange={e => {
                        let value = e.target.value
                        let ml = lapporteur
                        ml[editIndex].name = value;
                        setLApporteur(ml)
                      }}
                    />
                    <Form.Control
                      type="text"
                      name="apporteur"
                      required
                      defaultValue={lapporteur[editIndex].apporteur}
                      autocomplete="off"
                      placeholder="1000 €"
                      onChange={e => {
                        let value = e.target.value
                        let ml = lapporteur
                        ml[editIndex].apporteur = value;
                        setLApporteur(ml)
                      }}
                    />
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      selected={date}
                      selectsStart
                      autocomplete="off"
                      onChange={newDate => {
                        setDate(newDate)
                        let ml = lapporteur
                        ml[editIndex].date = newDate;
                        setLApporteur(ml)
                      }}
                      customInput={
                        <CustomDateInput
                          formControlProps={{
                            autocomplete: "off",
                            placeholder: 'jj/mm/aaaa',
                            //     ...register(`ScheduleStartDate${index}`)
                          }}
                        />
                      }
                    />
                  </Form.Group>

                  <Form.Group   >
                    <div style={{ display: 'flex', justifyContent: "space-between" }}>
                      <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Modifier'}</Button>
                      <a href="#" onClick={() => {
                        setEditIndex(null)
                        setEdit(false)
                      }}>Annuler</a>
                    </div>
                  </Form.Group>
                </Form>
              </>)}
            {!sadd && !finish && (
              <div style={{ display: 'flex', justifyContent: "space-between", marginTop: 20 }}>
                <a href="#" onClick={() => { setAdd(true) }}>
                  <FontAwesomeIcon
                    icon={'plus'}
                    className="text-primary fa-check"
                  /></a>

                <a href="#" onClick={() => {
                  if (confirm("Terminé ?")) {
                    finishing()
                  }
                }}>
                  <FontAwesomeIcon
                    icon={'check'}
                    className="text-primary fa-check"
                  /></a>
              </div>
            )}
            {sadd && !load && (
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="apporteur">
                  <Form.Control
                    type="text"
                    name="name"
                    required
                    autocomplete="off"
                    placeholder="Nom Prénom"
                  />
                  <Form.Control
                    type="text"
                    name="apporteur"
                    required
                    autocomplete="off"
                    placeholder="1000 €"
                    onChange={e => {
                      setValueApporteur(e.target.value)
                    }}
                  />
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={date}
                    selectsStart
                    autocomplete="off"
                    onChange={newDate => {
                      setDate(newDate)
                    }}
                    customInput={
                      <CustomDateInput
                        formControlProps={{
                          autocomplete: "off",
                          placeholder: 'jj/mm/aaaa',
                          //     ...register(`ScheduleStartDate${index}`)
                        }}
                      />
                    }
                  />
                </Form.Group>

                <Form.Group   >
                  {/* <Form.Label>(€ sans symbole)</Form.Label> */}
                  <div style={{ display: 'flex', justifyContent: "space-between" }}>
                    <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
                    <a href="#" onClick={() => {
                      setAdd(false)
                    }}>Annuler</a>
                  </div>
                </Form.Group>
              </Form>
            )}
          </>
        }

        if (hasApporteur) {
          return (<>
            {!load && (
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="deposit">
                  <Form.Control
                    type="text"
                    name="name"
                    required
                    autocomplete="off"
                    placeholder="Nom Prénom"
                  />
                  <Form.Control
                    type="text"
                    name="deposit"
                    required
                    autocomplete="off"
                    placeholder="1000 €"
                    onChange={e => {
                      setValueApporteur(e.target.value)
                    }}
                  />
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={date}
                    selectsStart
                    autocomplete="off"
                    onChange={newDate => {
                      setDate(newDate)
                    }}
                    customInput={
                      <CustomDateInput
                        formControlProps={{
                          autocomplete: "off",
                          placeholder: 'jj/mm/aaaa',
                          //     ...register(`ScheduleStartDate${index}`)
                        }}
                      />
                    }
                  />
                </Form.Group>

                <Form.Group   >
                  {/* <Form.Label>(€ sans symbole)</Form.Label> */}
                  <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
                </Form.Group>
              </Form>
            )}
          </>)
        } else {
          return <>
            <Form>
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  name="hasApporteur"
                  onChange={(e) => {
                    setHasApporteur(e.target.checked)
                  }}
                  label="C'est un apporteur"
                  checked={hasApporteur}
                />
              </Form.Group>
            </Form>
          </>
        }

      }
    },
    {
      accessor: 'solde',
      Header: 'Soldes',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { soldeuser, id, soldeFinish } = rowData.row.original
        const [load, setL] = useState(false);
        const [valuesolde, setValuesolde] = useState("");
        const [lsolde, setLsolde] = useState(soldeuser || [])
        const [loading, setLoading] = useState(false)
        const [date, setDate] = useState(null);
        const [sadd, setAdd] = useState(false);
        const [finish, setFinish] = useState(soldeFinish ? soldeFinish : false);


        const finishing = () => {
          if (loading) {
            return;
          }
          setLoading(true)
          firebase.firestore().collection('bookings').doc(id).update({ soldeFinish: true }).then(() => {
            setL(true);
            setDate(null);
            toast.success('Solde: Terminé.')
            setAdd(false);
            // mettre a jour et vider les champs
            setLoading(false);
            setFinish(true)
            setTimeout(() => {
              setL(false);
            }, 1000);
          }).catch((err) => {
            setLoading(false);
            toast.error("Solde: une erreur s'est produite")
          })
        }

        const handleSubmit = (event) => {
          // const form = event.currentTarget;
          event.preventDefault();
          event.stopPropagation();

          // récup le tableau d'acompte actuelle
          // ajouter les nouvelles valeur {}
          let vr = lsolde;
          vr.push({
            name: event.target?.name?.value,
            solde: valuesolde,
            date: date
          })
          // console.log('form', vr);
          // return;
          if (valuesolde && event.target?.name?.value && date) {
            let val = Number(valuesolde.replace(",", "."))
            if (val > 0) {
              if (loading) {
                return;
              }
              setLoading(true);
              firebase.firestore().collection('bookings').doc(id).update({ soldeuser: vr }).then(() => {
                setL(true);
                setDate(null);
                toast.success('Solde: Mise à jour.')
                setLsolde(vr)
                setAdd(false);
                // mettre a jour et vider les champs
                setLoading(false);
                setTimeout(() => {
                  setL(false);
                }, 1000);
              }).catch((err) => {
                setLoading(false);
                toast.error("Solde: Les champs sont invalide")
              })
            } else {
              toast.error("Solde: Les champs sont invalide")
            }
          } else {
            toast.error("Solde : Le champs est invalide")
          }
        }

        if (lsolde.length > 0) {
          return <>
            {finish && (
              <div style={{ display: 'flex', justifyContent: "end", paddingBottom: 10 }}>
                <FontAwesomeIcon
                  icon={'check'}
                  className="text-success fa-check "
                />
              </div>
            )}
            {lsolde?.map((d) => {
              return <>
                <small className="has-text-grey is-abbr-like">
                  {d?.name} <span style={{ fontWeight: "bold" }}>{d?.solde} €</span> le {useFormatDate(typeof d?.date?.toDate === 'function' ? d?.date?.toDate() : d?.date, {
                    day: 'numeric',
                    year: 'numeric',
                    month: 'short',
                  })}
                </small>
                <br />
              </>
            })}
            {!sadd && !finish && (
              <div style={{ display: 'flex', justifyContent: "space-between", marginTop: 20 }}>
                <a href="#" onClick={() => { setAdd(true) }}>
                  <FontAwesomeIcon
                    icon={'plus'}
                    className="text-primary fa-check"
                  /></a>

                <a href="#" onClick={() => {
                  if (confirm("Terminé ?")) {
                    finishing()
                  }
                }}>
                  <FontAwesomeIcon
                    icon={'check'}
                    className="text-primary fa-check"
                  /></a>
              </div>
            )}
            {sadd && !load && (
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="solde">
                  <Form.Control
                    type="text"
                    name="name"
                    required
                    autocomplete="off"
                    placeholder="Nom Prénom"
                  />
                  <Form.Control
                    type="text"
                    name="solde"
                    required
                    autocomplete="off"
                    placeholder="1000 €"
                    onChange={e => {
                      setValuesolde(e.target.value)
                    }}
                  />
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={date}
                    selectsStart
                    autocomplete="off"
                    onChange={newDate => {
                      setDate(newDate)
                    }}
                    customInput={
                      <CustomDateInput
                        formControlProps={{
                          autocomplete: "off",
                          placeholder: 'jj/mm/aaaa',
                          //     ...register(`ScheduleStartDate${index}`)
                        }}
                      />
                    }
                  />
                </Form.Group>

                <Form.Group   >
                  {/* <Form.Label>(€ sans symbole)</Form.Label> */}
                  <div style={{ display: 'flex', justifyContent: "space-between" }}>
                    <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
                    <a href="#" onClick={() => {
                      setAdd(false)
                    }}>Annuler</a>
                  </div>
                </Form.Group>
              </Form>
            )}
          </>
        }

        return <>
          {!load && (
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="solde">
                <Form.Control
                  type="text"
                  name="name"
                  required
                  autocomplete="off"
                  placeholder="Nom Prénom"
                />
                <Form.Control
                  type="text"
                  name="solde"
                  required
                  autocomplete="off"
                  placeholder="1000 €"
                  onChange={e => {
                    setValuesolde(e.target.value)
                  }}
                />
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={date}
                  selectsStart
                  autocomplete="off"
                  onChange={newDate => {
                    setDate(newDate)
                  }}
                  customInput={
                    <CustomDateInput
                      formControlProps={{
                        autocomplete: "off",
                        placeholder: 'jj/mm/aaaa',
                        //     ...register(`ScheduleStartDate${index}`)
                      }}
                    />
                  }
                />
              </Form.Group>

              <Form.Group   >
                {/* <Form.Label>(€ sans symbole)</Form.Label> */}
                <Button type="submit" disabled={loading}>{loading ? 'Chargement' : 'Envoyer'}</Button>
              </Form.Group>
            </Form>
          )}
        </>

      }
    },
    {
      accessor: 'total_pay',
      Header: 'Total (TTC)',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { total_pay } = rowData.row.original
        return <span>{total_pay} €</span>
      }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { files, id } = rowData.row.original
        return (<>

          <IconButton href={`/comptabilite/${id}`}
            variant="falcon-default"
            size="sm"
            icon="file"
            transform="shrink-3"
            className='me-2'
          >
            <span className="d-none d-sm-inline-block ms-1"></span>
          </IconButton>

          {files && files?.length && <p>{files.length} ficher{files?.length > 1 && '(s)'}</p>}

        </>
        )
      }
    }
  ];

  React.useEffect(() => {
    if (data.length === 0) {
      loadBooking()
    }
  }, []);


  function filtrerBooking(f) {
    const { checkin, checkout, month, year } = f
    return alldata.filter((book) => {
      let b = true
      // console.log('book', book);
      if (checkin && checkout) {
        if (book.statut?.value === 'confirmed') {
          if (!estDansLaPlage(book.checkin.toDate(), book.checkout.toDate(), checkin, checkout)) {
            b = false;
          }
        } else {
          b = false;
        }
      }
      if (book.pre !== month?.label) {
        b = false;
      }
      if (year?.value) {
        console.log(book.checkin.toDate().getFullYear(), Number(year?.value))
        if (book.checkin.toDate().getFullYear() !== Number(year?.value)) {
          b = false;
        } else {
          b = true;
        }

      }
      if (f.clientName?.length > 3 && book.cl.toLowerCase().includes(f.clientName?.toLowerCase())) {
        b = true;
      }


      return b;
    });

  }

  const searc = () => {
    // console.log('recherche en cours...', p)
    // let proper = p;

    let infosearch = { ...formd };
    // console.log('search', infosearch)
    let sser = filtrerBooking(infosearch);
    // console.log("sser", sser)
    const sortedData = sortByCheckin(sser);
    setData(sortedData)
    if (sser.length === 0) {
      toast.error('Aucun résultat')
    }

  }

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      return;
    }
    // if ((properties || [])?.length  > 0){
    // loadList(p => {
    //     searc(p)
    // }); 
    // }else{
    searc()
    // }


  };



  function AdvanceTableExample() {

    if (l) {
      return <p>Chargement...</p>
    }
    return (
      <AdvanceTableWrapper
        columns={columns}
        data={data}
        sortable
        pagination
        perPage={205}
      >
        <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
          <div id="orders-actions">
            {/* <IconButton  href="/newbooking"
        variant="falcon-default"
        size="sm"
        icon="plus"
        transform="shrink-3"
        className='me-2'
      >
        <span className="d-none d-sm-inline-block ms-1">Nouvelle réservation</span>
      </IconButton>  */}

            {/* { data && data.length > 0 && (
              <IconButton 

                variant="falcon-default"
                size="sm"
                icon="file"
                transform="shrink-3"
                className='me-2'
                  onClick={() => makeCsv(getTableDataForExport(data, colexport), `comptabilite-bo-house.csv`)}
  
              >
                Export des données en CSV 
                  </IconButton>)} */}

            <Col xs="auto" sm={6} lg={4}>
              <AdvanceTableSearchBox table />
            </Col>
          </div>
        </Col>
        <AdvanceTable
          table
          headerClassName="bg-200 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            bordered: true,
            striped: true,
            className: 'fs--1 mb-0 overflow-hidden'
          }}
        />
        <div className="mt-3">
          <AdvanceTableFooter
            rowCount={data.length}
            table
            rowInfo
            navButtons
            rowsPerPageSelection
          />
        </div>
      </AdvanceTableWrapper>
    );
  }


  return (

    <FalconComponentCard>
      <FalconComponentCard.Header
        title="Tableau de suivis"
        light={false}
        className="border-bottom border-200" noPreview={true}
      />

      <FalconComponentCard.Body >
        <Form noValidate onSubmit={handleSubmit}>
          <Row className="mb-3">

            <Form.Group as={Col} md="2" controlId="year">
              <Form.Label>Annee</Form.Label>
              <Select
                closeMenuOnSelect={true}
                options={yearlist}
                placeholder='Choisir...'
                classNamePrefix="react-select"
                value={valueYear}
                onChange={value => {
                  setValueYear(value)
                  let d = formd;
                  d['year'] = value;
                  setFrom(d);

                }}
              />
            </Form.Group>

            <Form.Group as={Col} md="2" controlId="month">
              <Form.Label>Mois</Form.Label>
              <Select
                closeMenuOnSelect={true}
                options={moislist}
                placeholder='Choisir...'
                classNamePrefix="react-select"
                value={valueMonth}
                onChange={value => {
                  setValueMonth(value)
                  let d = formd;
                  d['month'] = value;
                  setFrom(d);

                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="2" controlId="checkin">
              <Form.Label>Arrivée</Form.Label>
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={checkIn}
                minDate={new Date()}
                startDate={checkIn}
                endDate={checkOut}
                selectsStart
                onChange={newDate => {
                  let d = formd;
                  d['checkin'] = newDate;
                  setFrom(d)
                  setCheckIn(newDate)
                }}
                customInput={
                  <CustomDateInput
                    formControlProps={{
                      placeholder: 'jj/mm/yyyy',
                      //     ...register(`ScheduleStartDate${index}`)
                    }}
                  />
                }
              />
            </Form.Group>

            <Form.Group as={Col} md="2" controlId={`ScheduleEndDate`}>
              <Form.Label>Départ</Form.Label>

              <DatePicker
                selected={checkOut}
                minDate={checkIn}
                selectsEnd
                startDate={checkIn}
                endDate={checkOut}
                dateFormat="dd/MM/yyyy"
                onChange={newDate => {
                  let d = formd;
                  d['checkout'] = newDate;
                  setFrom(d)
                  setCheckOut(newDate)
                }}
                customInput={
                  <CustomDateInput
                    formControlProps={{
                      placeholder: 'jj/mm/yyyy',
                      //     ...register(`ScheduleStartDate${index}`)
                    }}
                  />
                }
              />
            </Form.Group>


            {/* Nouveau champ pour le nom du client */}
            <Form.Group as={Col} md="2" controlId="clientName">
              <Form.Label>Nom du client</Form.Label>
              <Form.Control
                type="text"
                placeholder="Entrez un nom"
                value={clientName || ""}
                onChange={(e) => {
                  let d = { ...formd };
                  d["clientName"] = e.target.value;
                  setFrom(d);
                  setClientName(e.target.value)
                }}
              />
            </Form.Group>


            <Form.Group as={Col} md="2">
              <Button type="submit" style={{ marginTop: 31 }} disabled={l}>{l ? 'Chargement' : 'Rechercher'}</Button>
            </Form.Group>

          </Row>
          <Row>
            <a href="#" onClick={() => {
              setFrom({})
              setCheckIn(null)
              setCheckOut(null)
              setValueMonth(null)
              setData(alldata);
              setValueYear(null);
              setClientName("")
            }}>Vider les champs</a>
          </Row>
        </Form>
      </FalconComponentCard.Body>
      <FalconComponentCard.Body>
        <AdvanceTableExample />
      </FalconComponentCard.Body>
    </FalconComponentCard>
  );
}

export default Comptabilite;
